import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';
import styles from './WidgetNoAccessEmptyState.module.scss';

export interface WidgetNoAccessEmptyStateProps {
  /**
   * Variant of the empty state:
   * - 'access': User doesn't have permission to view this widget (default)
   * - 'plan': Widget is not available on the company's current subscription plan
   */
  variant?: 'access' | 'plan';
}

/**
 * Empty state displayed when user doesn't have access permission
 * to view a specific widget type, or when the widget is not available
 * on the company's current subscription plan.
 */
export default function WidgetNoAccessEmptyState({
  variant = 'access',
}: WidgetNoAccessEmptyStateProps) {
  const { t } = useTranslation();

  const title =
    variant === 'plan'
      ? t('home.widget-plan-restriction-title')
      : t('home.widget-no-access-title');

  const text =
    variant === 'plan'
      ? t('home.widget-plan-restriction-description')
      : t('home.widget-no-access-description');

  return (
    <EmptyState
      icon={IconName.Cancel}
      title={title}
      text={text}
      rootClassName={styles.root}
      outlined={false}
    />
  );
}
